<div class="bloco-card">
  <div class="bloco-topo">
    <div class="bloco-topo-info">
      <h3 class="bloco-title">
        Minha rotina
        <mat-icon title="Dados dos últimos 30 dias" class="info-icon">info</mat-icon>
      </h3>
      <p class="bloco-sub">Organize suas atividades diárias e prioridades</p>
    </div>
    <div class="bloco-acoes">
      <a routerLink="/tarefas" class="btn-outline">Ver todas</a>
    </div>
  </div>

  <ng-container *ngIf="!loading; else skeleton">
    <div class="contadores">
      <div class="contador contador--blue">
        <span class="contador-num">{{ paraHoje }}</span>
        <span class="contador-label">PARA HOJE</span>
      </div>
      <div class="contador contador--danger">
        <span class="contador-num">{{ atrasadas | number }}</span>
        <span class="contador-label">ATRASADAS</span>
      </div>
      <div class="contador contador--yellow">
        <span class="contador-num">{{ pendentes | number }}</span>
        <span class="contador-label">PENDENTES</span>
      </div>
      <div class="contador contador--info">
        <span class="contador-num">{{ concluidas }}</span>
        <span class="contador-label">CONCLUÍDAS</span>
      </div>
    </div>

    <div class="tarefas-lista">
      <div class="tarefa-item" *ngFor="let t of proximasTarefas">
        <div class="tarefa-icone">
          <mat-icon [fontSet]="getIconeTarefa(t.actionDescription).fontSet">
            {{ getIconeTarefa(t.actionDescription).nome }}
          </mat-icon>
        </div>
        <div class="tarefa-info">
          <span class="tarefa-nome">{{ t.actionDescription }} • {{ t.workName }}</span>
          <div class="tarefa-meta">
            <span class="tarefa-status"
              [class.status--atrasada]="t.isAtrasada"
              [class.status--pendente]="!t.isAtrasada">
              {{ t.isAtrasada ? 'ATRASADA' : 'PENDENTE' }}
            </span>
            <span class="tarefa-data">• {{ t.followUpLabel }}</span>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="proximasTarefas.length === 0">
        Nenhuma tarefa encontrada.
      </div>
    </div>
  </ng-container>

  <ng-template #skeleton>
    <div class="contadores">
      <div class="contador skeleton-box" *ngFor="let i of [1,2,3,4]"></div>
    </div>
    <div class="tarefas-lista">
      <div class="skeleton-line" *ngFor="let i of [1,2,3]"></div>
    </div>
  </ng-template>
</div>